var modCartDetail = function(){
    var scope = ".js-mod-cart-detail";
    var scopeAddress = ".js-mod-checkout-address";

    function updateCartContents(){
        var $mod = $(scope);
        gvf.endpoint(
            "web\\shopCartController::getCartContents",
            [],
            function(response){
                if(response.status=="ok"){
                    var $cart = $(response.html);
                    $mod.replaceWith($cart);
                    $mod = $cart;
                    ui.init($mod);

                    if(document.getElementById('paymentDetail')){
                        location.reload();
                    }
                }
            }
        );
    }

    function getCartDetail() {
        var $mod = $(scopeAddress);
        gvf.endpoint(
            "web\\shopProcessController::showViewCartDetail",
            null,
            function(response){
                if(response){
                    var $cartModal = $mod.find(scopeAddress+"__cart-detail");
                    var $html = $(response.html);
                    $html.removeClass("web-mod-cart-detail");
                    $cartModal.append($html);
                    ui.init($cartModal);

                }else{
                    utils.alertEndpointResponse(response);
                }
            }
        );
    }

    ui.ready(
        scope,
        function($mod){
            function setProductQuantity($item,quantity){
                $item.find(scope+"__product-input").val(quantity);
                gvf.delay(
                    500,
                    function(){
                        shopCart.setProductQuantity(
                            $item.data("product-id"),quantity,
                            function(data){
                                $item.data("cart-quantity",data.quantity);
                                $item.trigger("web:cartQuantityUpdate",data);
                            },
                            null,
                            $item.data("repeat-id"),
                            $item.data("days")
                        );
                    }
                );
            }

            $mod.find("[name=comments]").closest(".js-form-field").on(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopProcessController::setShopProcessComments",
                        [$mod.find("[name=comments]").val()],
                        function(response){
                        }
                    );
                }
            );

            $mod.find(scope+"__product-quantity-btn").click(
                function(ev){
                    ev.preventDefault();
                    var $item = $(this).closest(scope+"__product");
                    var newQuantity = parseInt($item.find(scope+"__product-input").val())+parseInt($(this).data("add"));
                    setProductQuantity($item,newQuantity);
                }
            );

            $mod.find(scope+"__product-remove").click(
                function(ev){
                    ev.preventDefault();
                    var $item = $(this).closest(scope+"__product");
                    setProductQuantity($item,0);
                }
            );

            $mod.find(scope+"__product-input").keyup(
                function(ev){
                    ev.preventDefault();
                    var $item = $(this).closest(scope+"__product");
                    var quantity = $(this).val();
                    if(!isNaN(quantity) && quantity==parseInt(quantity)){
                        setProductQuantity($item,quantity);
                    }
                }
            );

            $mod.find(scope+"__promo-code-form").submit(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopProcessController::redeemPromoCode",
                        [$mod.find(scope+"__promo-code-input").val()],
                        function(response){
                            utils.alertEndpointResponse(response);
                            if(response.status=="ok"){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    );
                }
            );

            $mod.find(scope+"__promo-code-cancel").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopProcessController::cancelRedeemPromoCode",
                        [$(this).data("id")],
                        function(response){
                            if(response.status=="ok"){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    );
                }
            );

            $mod.find(scope+"__promo-coupon-cancel").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopProcessController::cancelRedeemPromoCoupon",
                        [$(this).data("id")],
                        function(response){
                            if(response.status=="ok"){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    );
                }
            );

            $mod.find(scope+"__loyalty-coupon-cancel").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopProcessController::cancelRedeemLoyaltyCoupon",
                        [$(this).data("id")],
                        function(response){
                            if(response.status=="ok"){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    );
                }
            );

            $mod.find(scope+"__loyalty-points").click(
                function(ev){
                    ev.preventDefault();
                    if($(this).closest(".is-in-use").length==0){
                        gvf.endpoint(
                            "web\\shopProcessController::applyLoyaltyDiscount",
                            [],
                            function(response){
                                utils.alertEndpointResponse(response);
                                updateCartContents();
                                getCartDetail();
                            }
                        );
                    }
                }
            );

            $mod.find("[name=shop_subscription_type_id]").on("change",function(event){
                event.preventDefault();
                var shopSubscriptionTypeId = $mod.find("[name=shop_subscription_type_id]:checked").val();
                gvf.endpoint(
                    "web\\shopProcessController::applySubscriptionDiscount",
                    [shopSubscriptionTypeId],
                    function(response){
                        if(response && response.messsages && response.messsages.length>0){
                            utils.alertEndpointResponse(response);
                        }
                        updateCartContents();
                        getCartDetail();
                    }
                );
            })

        }
    );

    ui.readyBody(
        function($body){
            $body.on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    gvf.delay(
                        1000,
                        function(){
                            updateCartContents();
                        }
                    );
                }
            );
        }
    );

    return {
        updateCartContents: updateCartContents,
        getCartDetail: getCartDetail
    }
}();
